import type { IconData } from '@stacksjs/iconify-core'

export const shippingBox1: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"3\"><path d=\"M3.545 39.596a5.25 5.25 0 0 0 4.859 4.859C11.72 44.719 16.914 45 24 45c7.085 0 12.28-.281 15.596-.545a5.25 5.25 0 0 0 4.859-4.859C44.719 36.28 45 31.086 45 24c0-7.085-.281-12.28-.545-15.596a5.25 5.25 0 0 0-4.859-4.859C36.28 3.281 31.086 3 24 3c-7.085 0-12.28.281-15.596.545a5.25 5.25 0 0 0-4.859 4.859C3.281 11.72 3 16.914 3 24c0 7.085.281 12.28.545 15.596Z\"/><path stroke-linejoin=\"round\" d=\"M30.676 3.089c-.045 4.26-.354 8.618-.533 10.831a.987.987 0 0 1-1.45.79l-4.46-2.359a.5.5 0 0 0-.467 0l-4.458 2.36a.987.987 0 0 1-1.45-.79c-.18-2.214-.488-6.572-.534-10.832\"/><path d=\"M36 36h-9m9-8h-5\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default shippingBox1
